import type { Doc } from "building-types/doc";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { getGroupHiddenState, updateGroupHidden } from "./docGroupState";
import docEntityGetChildren from "./entity/docEntityGetChildren";
import { docEntityIsHidden } from "./entity/docEntityHidable";
import { docForeignHashTableApplyOp } from "./entity/docForeignHashTableOps";
import { entitySetNew } from "./entity/entitySet";

// Update the hidden state of the parent based on its children.
export function docUpdateGroupHidden(doc: Doc, parentHandle: DocEntityHandle): Doc {
  const childHandles = docEntityGetChildren(doc, parentHandle, true);
  const allHidden = childHandles.every((handle) => docEntityIsHidden(doc, handle));
  if (docEntityIsHidden(doc, parentHandle) !== allHidden) {
    return {
      ...doc,
      hidden: docForeignHashTableApplyOp(doc.hidden, entitySetNew([parentHandle]), "XOR"),
    };
  } else {
    return doc;
  }
}

/**
 * Recompute group hidden state from members.
 *
 * Group locked state is independent (LEVEL-like): only the GROUP hash lives in `doc.locked`, and
 * members inherit at read time. Membership changes do not rewrite group lock.
 */
export function docUpdateGroupState(doc: Doc, parentHandle: DocEntityHandle): Doc {
  const childHandles = docEntityGetChildren(doc, parentHandle, true);
  const allHidden = getGroupHiddenState(doc, childHandles);
  return updateGroupHidden(doc, parentHandle, allHidden);
}
